<style xmlns="http://www.w3.org/1999/html">
    .header-home-nav, .home-footer {
        background: url(~@/assets/hometeacher/images/green-green-fon.png) !important;
        padding-bottom: 10px;
    }

</style>

<template>
    <div>
        <div class="container-fluid blue-letters-girl">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / Годовой курс Английский с рождения
                        </div>

                        <h1 class="desktop-vers">Годовой курс <span class="yellow-span">Английский с рождения</span>
                        </h1>
                        <h1 class="mobile-vers">Годовой курс<br> <span class="yellow-span">Английский с рождения</span>
                        </h1>

                        <h3>для родителей с детьми от 1 года</h3>
                        <div class="mobile-vers" style="margin-left: -15px; margin-right: -15px;"><img
                                src="~@/assets/hometeacher/images/anglomama-mob.jpg"
                                alt="Годовой курс Английский с рождения" class="mobile girl-notik"></div>
                        <p>Курс для родителей, которые начинали обучать своих детей английскому языку с самого
                            рождения.</p>

                        <p><span class="strong-black">При помощи уроков-эпизодов и регулярных онлайн-консультаций преподавателя родители начнут правильно говорить с ребенком на иностранном языке.</span>
                        </p>

                        <p>Слова и фразы для повседневной жизни ребенка и родителей преподает носитель языка с
                            превосходным, правильным произношением. Мы предоставляем родителям все необходимые материалы
                            и пособия, чтобы обучение было продуктивным и корректным. С первых занятий родители смогут
                            создать вокруг малыша английскую языковую среду. И вскоре ребенок начнет воспринимать и
                            понимать английский так же, как родной русский.</p>

                        <p class="desktop-vers"><span class="blue-fon-text">Детям в школе предстоит изучать английский. Начните делать это</span>
                            <br>
                            <span class="blue-fon-text">с младенчества, чтобы иностранный язык стал вторым родным.</span>
                        </p>

                        <p class="mobile-vers"><span class="blue-fon-text">Детям в школе предстоит</span><br>
                            <span class="blue-fon-text">изучать английский.</span><br>
                            <span class="blue-fon-text">Начните делать это</span><br>
                            <span class="blue-fon-text">с младенчества, чтобы</span><br>
                            <span class="blue-fon-text">иностранный язык</span><br>
                            <span class="blue-fon-text">стал вторым родным.</span></p>
                        <div class="knpk"><a href="javascript:void(0);" @click="tryFree">Подать заявку</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid vkurs">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check">
                        <label for="check"><h2 class="iba">Курс "Английский с рождения"</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <img src="~@/assets/hometeacher/images/anglomama-teacher.jpg"
                                 alt="Годовой курс английского языка">
                            <div>
                                <p style="font-size: 3px;">&nbsp;</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">1 лекция</span> для англомам</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">71 урок-эпизод</span> для родителей для изучения в течение
                                    30 минут каждый</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">142 онлайн-теста</span> для родителей</p>
                                <div class="chek"></div>
                                <p><span class="strong-black">90 рабочих листов</span> для родителей</p>
                                <p style="font-size: 3px;">&nbsp;</p>
                                <div class="red-chek"></div>
                                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Первая установочная сессия с преподавателем</span>
                                </p>
                                <div class="red-chek"></div>
                                <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Последующие онлайн-консультации 1 раз в месяц</span>
                                </p>
                                <p>задайте вопросы, пройдите тестирование уровня владения языком, получите
                                    индивидуальные рекомендации</p>
                                <div class="red-chek"></div>
                                <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету</span>
                                </p>

                            </div>
                            <h3>Длительность всего курса: 1 год. </h3>
                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2 class="iba desktop-vers">Курс "Английский с рождения"</h2>

                        <img src="~@/assets/hometeacher/images/anglomama-teacher.jpg"
                             alt="Годовой курс Английский с рождения">

                        <div class="chek"></div>
                        <p><span class="strong-black">1 лекция</span> для англомам</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">71 урок-эпизод</span> для родителей для изучения в течение 30
                            минут каждый</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">142 онлайн-теста</span> для родителей</p>
                        <div class="chek"></div>
                        <p><span class="strong-black">90 рабочих листов</span> для родителей</p>
                        <p style="font-size: 3px;">&nbsp;</p>
                        <div class="red-chek"></div>
                        <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Первая установочная сессия с преподавателем</span>
                        </p>
                        <div class="red-chek"></div>
                        <p class="onlain-kons" style="background-image: none;"><span class="strong-black">Последующие онлайн-консультации 1 раз в месяц</span>
                        </p>
                        <p>задайте вопросы, пройдите тестирование уровня владения языком, получите индивидуальные
                            рекомендации</p>
                        <div class="red-chek"></div>
                        <p class="bezlimit-group" style="background-image: none;"><span class="strong-black">За дополнительную плату приобретайте индивидуальные онлайн-занятия с преподавателем по предмету</span>
                        </p>


                        <h3>Длительность всего курса: 1 год.</h3>
                    </div>

                </div>
            </div>
        </div>

        <div class="container-fluid skytop"></div>
        <div class="container-fluid skyfon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>С “Полиглотиками” учить<br> детей английскому — <br>
                            <span class="veselo">просто и увлекательно!</span></h2>
                        <p>На первой онлайн-консультации тренер проведет диагностику родителя, подберет уровень курса,
                            предложит план обучения и расскажет,
                            как применять полученные родителем знания для создания билингвальной среды дома для ребенка.
                            Ваша заявка открывает вам один бесплатный урок-эпизод курса и тренажеры к нему, а также
                            лекцию-инструкцию по методике для англомам.</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать
                            бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid skydown"></div>

        <div class="container-fluid blue-letters-back">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabonement">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>

        <div class="container-fluid align-middle getpresent">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3>Мы разучим:</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 px-lg-0 px-5">
                        <div class="skill-span skill-span-1">Купание, ситуации в ванной</div>
                        <div class="skill-span skill-span-2">Прогулка</div>
                        <div class="skill-span skill-span-3">Просыпаемся, умываемся, одеваемся</div>
                        <div class="skill-span skill-span-4">Наша семья</div>
                        <div class="skill-span skill-span-5">Еда</div>
                        <div class="skill-span skill-span-6">Высаживание на горшок</div>
                        <div class="skill-span skill-span-7">Ушибы и ссадины, у врача</div>
                        <div class="skill-span skill-span-1">Погремушки и игрушки</div>
                        <div class="skill-span skill-span-2">Времена года</div>
                        <div class="skill-span skill-span-3">Рисуем: цвета</div>
                        <div class="skill-span skill-span-4">Праздники</div>
                    </div>
                </div>
            </div>
        </div>

        <!--
        <div class="container-fluid align-middle getpresent">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="desktop-vers" style="text-align: left;">При покупке курса <span class="toget">вы получаете в подарок:</span>
                        </h3>
                        <h3 class="mob">При покупке курсы <br>
                            <div class="toget">вы получаете в<br> подарок 5 курсов:</div>
                        </h3>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <StudyProductCourseList
                                :courses="courses"
                                @about="aboutCourse"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div>
        -->
        <div class="container-fluid obuchenie">
            <div class="container">
                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check1">
                        <label for="check1"><h2 class="iba">Как проходит обучение</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight1"></div>
                                    <div class="bluekrug">1</div>
                                    <p>Подайте заявку на <span class="strong-black">онлайн-консультацию, чтобы оценить уровень своих способностей и получить рекомендации по обучению.</span>
                                    </p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">2</div>
                                    <p>Каждую неделю проходите новые <span class="strong-black">уроки-эпизоды</span>.
                                    </p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">3</div>
                                    <p>Во время занятия используйте <span class="strong-black">глоссарий по теме</span>
                                        в формате распечатанных рабочих листов из раздела курса «Материалы».</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug">4</div>
                                    <p><span class="strong-black">Выполняйте домашние задания</span> в формате
                                        онлайн-тренажеров.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="strela strelheight2"></div>
                                    <div class="bluekrug" style="margin-bottom: 65px;">5</div>
                                    <p><span class="strong-black">Применяйте дома разученные фразы,</span> обращаясь к
                                        своему ребенку.</p>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="bluekrug">6</div>
                                    <p>Наставник регулярно проводит <span class="strong-black">онлайн-встречи</span> с
                                        родителями для контроля достижения результатов. <span class="strong-black">Поддержка 7/24</span>
                                        в чате.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Как проходит обучение</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight1"></div>
                        <div class="bluekrug">1</div>
                        <p>Подайте заявку на <span class="strong-black">онлайн-консультацию, чтобы оценить уровень своих способностей и получить рекомендации по обучению.</span>
                        </p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">2</div>
                        <p>Каждую неделю проходите новые <span class="strong-black">уроки-эпизоды</span>.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">3</div>
                        <p>Во время занятия используйте <span class="strong-black">глоссарий по теме</span> в формате
                            распечатанных рабочих листов из раздела курса «Материалы».</p>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-9">
                        <img src="~@/assets/hometeacher/images/strelka-krivaya.png" class="strelka-krivaya">
                    </div>

                    <div class="col-12 col-sm-3">
                        <img src="~@/assets/hometeacher/images/hello.png" class="hello">
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">4</div>
                        <p><span class="strong-black">Выполняйте домашние задания</span> в формате онлайн-тренажеров.
                        </p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="strela strelheight2"></div>
                        <div class="bluekrug">5</div>
                        <p><span class="strong-black">Применяйте дома разученные фразы,</span> обращаясь к своему
                            ребенку.</p>
                    </div>
                    <div class="col-12 col-sm-3">
                        <div class="bluekrug">6</div>
                        <p>Наставник регулярно проводит <span class="strong-black">онлайн-встречи</span> с родителями
                            для контроля достижения результатов. <span class="strong-black">Поддержка 7/24</span> в
                            чате.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter desktop-vers" style="margin-top: 90px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>
        <div class="container-fluid white-bg no-shadow sm-video" style="padding-top: 0px;">
            <div class="container align-middle" style="text-align: center;">
                <div class="row">
                    <div class="col-12">
                        <h2 style="line-height: 1.3;">По окончании обучения<br>
                            <span class="sertifikat">родитель и ребенок получают сертификат</span></h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <img src="~@/assets/hometeacher/images/sertif-anglomama.jpg">
                    </div>
                </div>

            </div>
        </div>

        <div class="container-fluid bigwavetop desktop-vers"></div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">
                <div class="row desktop-vers">
                    <div class="col-12">
                        <h2>Смотрите видео о наших курсах</h2>
                    </div>
                </div>
                <div class="row desktop-vers">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:3}}">

                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/nEyXLpCJCwE" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Представление курса Английский с рождения</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/9MIX_YzZD50" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Английский с рождения. Предметы, окружающие младенца, действия</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/-cx0zbqOkaw" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Английский с рождения. Кормление грудью</p>
                            </div>
                            <div class="centers-text mx-3">
                                <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                        src="https://www.poliglotiki.ru/embed/gNP08AqWUOU" frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <p>Английский с рождения. Я родился</p>
                            </div>

                        </carousel>
                    </div>
                </div>


                <div class="row mobile-vers">
                    <div class="col-12">
                        <input type="checkbox" id="check3">
                        <label for="check3"><h2>Смотрите видео о наших курсах</h2>
                            <img src="~@/assets/hometeacher/images/galocka.png" class="galocka"></label>
                        <div class="block">

                            <carousel :responsive="{0:{items:1},1000:{items:3}}">

                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/nEyXLpCJCwE" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Представление курса Английский с рождения</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/9MIX_YzZD50" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Английский с рождения. Предметы, окружающие младенца, действия</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/-cx0zbqOkaw" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Английский с рождения. Кормление грудью</p>
                                </div>
                                <div class="centers-text mx-3">
                                    <iframe class="mt-xl-5 mb-xl-5 rounded-xl vidos"
                                            src="https://www.poliglotiki.ru/embed/gNP08AqWUOU" frameborder="0"
                                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen></iframe>
                                    <p>Английский с рождения. Я родился</p>
                                </div>

                            </carousel>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter desktop-vers"
                             style="margin-top: 70px; margin-bottom: -10px;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid liniya mobile-vers"></div>

        <div class="container-fluid white-bg no-shadow sm-video">
            <div class="container align-middle">

                <div class="row">
                    <div class="col-12">
                        <h2 class="otzivh2">Отзывы родителей</h2>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <carousel :responsive="{0:{items:1},1000:{items:2}}">


                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/tatyana-tumanova.jpg">
                                <span class="nameotzyv">Татьяна Туманова</span>
                                <div class="text-otziv">Отличный курс. Ребёнку очень нравится. Все понятно и доступно.
                                    Приятные преподаватели
                                </div>
                            </div>


                            <div class="centers-text mx-3">
                                <img class="photootzyv indotz" alt=""
                                     src="@/assets/hometeacher/images/elena-serebryakova.jpg">
                                <span class="nameotzyv">Елена Серебрякова</span>
                                <div class="text-otziv">Курс полезный, особенно, малышам которые занимаются в
                                    Полиглотиках он-лайн и на очных занятиях. Так как он является словарной базой для
                                    занятий, детей по ним обучают...
                                </div>
                            </div>


                        </carousel>
                    </div>
                </div>
                <div class="row" style="margin-top: 70px; margin-bottom: 50px;">
                    <div class="col-12" style="text-align: center;">
                        <a href="https://poliglotiki.com/home-teacher/course/anglijskij-s-rozhdeniya-part-1/details"
                           class="allotzv">Читать все отзывы</a>
                    </div>
                </div>

            </div>
        </div>


        <div class="container-fluid skytop"></div>
        <div class="container-fluid skyfon">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <h2>С “Полиглотиками” учить<br> детей английскому — <br>
                            <span class="veselo">просто и увлекательно!</span></h2>
                        <p>На первой онлайн-консультации тренер расскажет, как применять полученные знания для создания
                            билингвальной среды для ребенка. Курс имеет весь набор самых необходимых материалов для
                            мамы, которые помогут максимально вникнуть в язык: глоссарий, онлайн-тренажеры для родителя
                            и рабочие листы. Регулярные живые онлайн-консультации позволят разъяснить все вопросы.
                            Результат: малыш вместе с мамой пополнит словарь 300 полезными фразами на английском
                            языке!</p>
                    </div>

                    <div class="col-12 col-sm-5">
                        <img src="~@/assets/hometeacher/images/strlka.png">
                        <div class="knpk-yellow"><a href="javascript:void(0);" @click="tryFree">Попробовать
                            бесплатно</a></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid skydown-white desktop-vers"></div>
        <div class="container-fluid skydown mobile-vers"></div>
        <div class="container-fluid last-stav">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="desktop-vers">Ставьте цели и <span class="viborabon-last">выбирайте абонемент:</span>
                        </h2>
                        <h2 class="mobile-vers">Ставьте цели<br>
                            <div class="viborabonement">и выбирайте<br> абонемент:</div>
                        </h2>
                    </div>
                </div>

                <StudyProductSubscriptionList
                        :subscriptions="subscriptions"
                        @order="orderSubscription"
                />

            </div>
        </div>

        <Entry/>

    </div>


</template>

<script>
    import carousel from "vue-owl-carousel";
    import moment from 'moment';
    import StudyProductSubscriptionList from "./Study/landing/StudyProductSubscriptionList";
    import studyProductApi from "../data/StudyProductApi";
    import StudyProductCourseList from "./Study/landing/StudyProductCourseList";
    import Entry from "./Entry";
    import courseApi from "../data/CourseApi";

    export default {
        components: {
            StudyProductCourseList,
            StudyProductSubscriptionList,
            carousel,
            Entry,
        },
        name: "GodovojKursAnglijskogo",

        data: function () {
            return {
                title: null,
                slug: 'godovoj-kurs-anglijskij-s-rozhdeniya',
                subscriptions: [],
                freeSubscription: null,
                promoSuscription: null,
                courses: [],
            }
        },

        mounted() {
            moment.locale(this.$i18n.locale)
            this.loading = true

            studyProductApi.fetchStudyProductSlug(this.slug)
                .then(response => {
                    this.subscriptions = response.subscriptions.filter(s => {
                        if (s.price <= 0) {
                            this.freeSubscription = s
                            return false
                        }
                        return s.price > 0
                    })
                    this.courses = response.courses

                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            /*courseApi.fetchCourseBySlug('anglijskij-s-rozhdeniya-part-1')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            courseApi.fetchCourseBySlug('anglijskij-s-rozhdeniya-part-2')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })

            courseApi.fetchCourseBySlug('anglijskij-s-rozhdeniya-part-3')
                .then(response => {
                    this.courses.push(response)
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })*/
        },

        methods: {
            orderSubscription(subscription) {
                this.$router.push('/subscription/order/' + subscription.idsubscription)
            },
            aboutCourse(course) {
                this.$router.push('/course/' + course.slug + '/details')
            },
            tryFree() {
                if (this.freeSubscription) {
                    this.$router.push('/subscription/order/' + this.freeSubscription.idsubscription)
                }
            }
        },

        metaInfo() {
            return {
                title: 'Годовой курс Английского языка',
                meta: [
                    {
                        vmid: 'description',
                        name: 'description',
                        content: 'Годовой курс Английского языка для детей от 12 месяцев до 12 лет.'
                    }
                ]
            }
        },
    }
</script>

<style scoped>

    .blue-letters-girl {
        background: url(~@/assets/hometeacher/images/anglomama.jpg) no-repeat center;
        text-align: left;
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 10px;
        min-height: 878px;
    }

    .breadcrumbs {
        font-size: 14px;
        background: #fff;
        max-width: 330px;
        padding-left: 7px;
        border-radius: 10px;
        margin-left: -7px;
    }

    .blue-letters-girl h1 {
        font-size: 43px;
        font-family: Manrope Black;
        margin-top: 15px;
        margin-bottom: -10px;
        color: #000;
        background: url(~@/assets/hometeacher/images/yellow-top.png) no-repeat right center;
        max-width: 818px;
        padding-top: 2px;
        padding-bottom: 10px;
    }

    .blue-letters-girl h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        margin-bottom: 20px;
        color: #000;
    }

    .yellow-span {
        margin-left: 6px;
    }

    .blue-letters-girl p {
        font-size: 20px;
        max-width: 750px;
        line-height: 1.4;
    }

    .blue-fon-text {
        background: #00b4f1;
        color: #fff;
        border-radius: 15px;
        padding: 2px 10px;
        line-height: 1.8;
        font-size: 19px;
        font-family: 'Manrope Book';
        margin-left: 0px;
    }

    .knpk {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 22px;
        color: #fff;
        padding: 15px 30px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 30%);
        margin-top: 25px;
    }

    .knpk:hover {
        background: #49d92c;
    }

    .knpk a {
        color: #fff;
    }

    .vkurs {
        padding-top: 60px;
    }

    .vkurs h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 30px;
    }

    .vkurs h3 {
        font-size: 25px;
        font-family: "Manrope Bold";
        color: #231c37;
        margin-top: 30px;
    }

    .vkurs img {
        float: right;
        margin-right: -35px;
    }

    .vkurs p {
        font-size: 20px;
        margin-left: 35px;
        line-height: 1.4;
        color: #000;
        max-width: 635px;
    }

    .leftp {
        margin-left: 0px !important;
    }

    .red-chek {
        background: url(~@/assets/hometeacher/images/red-chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .bezlimit-group {
        background-image: url(~@/assets/hometeacher/images/bezlimit-group.png);
        line-height: 1.6 !important;
        padding-left: 8px;
        padding-bottom: 3px;
        padding-right: 8px;
        max-width: 589px !important;
    }

    .onlain-kons {
        background-image: url(~@/assets/hometeacher/images/onlain-kons.png);
        line-height: 1.4 !important;
        padding-left: 8px;
        padding-bottom: 0px;
        padding-right: 8px;
        max-width: 654px !important;
        padding-top: 2px;
    }

    .chek {
        background: url(~@/assets/hometeacher/images/chek.png) no-repeat 0 0;
        font-size: 20px;
        float: left;
        width: 25px;
        height: 20px;
        margin-top: 8px;
    }

    .skytop {
        background: url(~@/assets/hometeacher/images/fiolettop.png) repeat center;
        width: 100%;
        height: 90px;
        margin-top: 50px;
    }

    .skydown {
        background: url(~@/assets/hometeacher/images/fioletdown.png) repeat center;
        width: 100%;
        height: 92px;
    }

    .skydown-white {
        background: url(~@/assets/hometeacher/images/fioletdown-white.png) repeat center;
        width: 100%;
        height: 93px;
    }

    .skyfon {
        background: #70529e;
        min-height: 350px;
        overflow: hidden;
        padding-bottom: 30px;
        padding-top: 30px;
    }

    .skyfon img {
        float: right;
        margin-right: -415px;
        margin-top: 165px;
        height: 33px;
        max-width: 100%;
    }

    .skyfon h2 {
        font-family: Manrope Bold Alt;
        font-size: 40px;
        color: #fff;
        margin-top: 50px;
        line-height: 1.3;
    }

    .skyfon p {
        color: #fff;
        font-size: 18px;
        line-height: 1.4;
        margin-top: 20px;
    }

    .veselo {
        background-image: url(~@/assets/hometeacher/images/prosto.png);
        padding-left: 8px;
        padding-top: 2px;
        padding-bottom: 9px;
        color: #000;
        padding-right: 8px;
    }

    .knpk-yellow {
        border-radius: 35px;
        text-align: center;
        max-width: 390px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#ffce00), to(#fbfe00));
        font-size: 24px;
        padding: 15px 30px;
        -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
        margin-top: 150px;
    }

    .knpk-yellow:hover {
        background: #fbfe00;
    }

    .knpk-yellow a {
        color: #000;
    }

    .blue-letters-back {
        background-image: url(~@/assets/hometeacher/images/blue-letters-back.png);
        margin-top: 0;
        padding-bottom: 100px;
        text-align: left;
        padding-top: 70px;
    }

    .blue-letters-back h2 {
        font-size: 40px;
        font-family: "Manrope Black";
        color: #262239;
    }

    .viborabonement {
        background-image: url(~@/assets/hometeacher/images/viborabonement.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }


    .abonement a {
        border-radius: 35px;
        max-width: 230px;
        font-family: Manrope Bold Alt;
        background: -webkit-gradient(linear, left bottom, left top, from(#39ab22), to(#49d92c));
        font-size: 20px;
        color: #fff;
        padding: 14px 35px;
        box-shadow: 0 3px 3px rgb(0 0 0 / 20%);
        text-decoration: none;
    }

    .abonement a:hover {
        background: #49d92c;
    }

    .getpresent {
        box-shadow: inset 0 3px 5px #00000038;
        padding-top: 100px;
    }

    .getpresent h3 {
        font-size: 30px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 40px;
        text-align: center;
    }

    .skill-span {
        color: #fff;
        display: inline-block;
        font-weight: 700;
        font-size: 20px;
        line-height: 35px;
        border-radius: 17px;
        height: 35px;
        text-align: center;
        padding-left: 20px;
        padding-right: 20px;
        margin-right: 25px;
        margin-bottom: 30px;
    }

    .skill-span-1 {
        background-color: #b01ced;
    }

    .skill-span-2 {
        background-color: #00b4f1;
    }

    .skill-span-3 {
        background-color: #00963f;
    }

    .skill-span-4 {
        background-color: #33c416;
    }

    .skill-span-5 {
        background-color: #fa8500;
    }

    .skill-span-6 {
        background-color: #0450c3;
    }

    .skill-span-7 {
        background-color: #ed1c24;
    }

    .bigwavetop {
        background: url(~@/assets/hometeacher/images/bigwavetop.png) no-repeat center;
        width: 100%;
        height: 190px;
    }


    .obuchenie {
        padding-top: 100px;
        padding-bottom: 40px;
        box-shadow: inset 0 3px 5px #00000038;
    }

    .obuchenie h2, .sm-video h2 {
        font-size: 40px;
        font-family: Manrope Bold Alt;
        color: #262239;
        margin-bottom: 60px;
    }

    .obuchenie p {
        font-size: 18px;
        width: 270px;
        line-height: 1.4;
    }

    .strela {
        background-image: url(~@/assets/hometeacher/images/strela.png);
        width: 176px;
        height: 19px;
        margin-top: 20px;
        left: 100px;
        position: absolute;
    }

    .bluekrug {
        width: 60px;
        height: 60px;
        border: 3px solid #00b4f1;
        border-radius: 50%;
        text-align: center;
        color: #4f4d5c;
        background: #fff;
        padding-top: 10px;
        font-size: 24px;
        font-family: "Manrope Bold";
        margin-bottom: 20px;
        position: relative;
        z-index: 10;
    }

    .strelka-krivaya {
        margin-left: 35px;
        margin-top: -40px;
        padding-bottom: 5px;
        max-width: 100%;
    }

    .hello {
        position: absolute;
        top: -150px;
        left: -20px
    }

    .sertifikat {
        background-image: url(~@/assets/hometeacher/images/sertif-anglomama.png);
        padding-left: 8px;
        padding-top: 3px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .sm-video {
        padding-top: 80px;
    }

    .sm-video p {
        margin-top: -100px;
        font-size: 18px;
        font-family: 'Manrope Book';
        color: #000;
        text-align: center;
    }

    .vidos {
        width: 100%;
        height: 192px;
        border-radius: 15px;
        margin-right: 0 !important;
        margin-bottom: 100px !important;
    }

    .otzivh2 {
        font-size: 36px !important;
        font-family: "Manrope Black" !important;
        color: #231c37 !important;
        margin-bottom: 60px !important;
    }

    .indotz {
        float: left;
        margin-right: 20px;
        margin-bottom: 10px;
    }

    .nameotzyv {
        font-size: 21px;
        font-family: Manrope Bold;
        display: block;
        color: #000;
    }

    .text-otziv {
        font-size: 17px;
        color: #000;
        line-height: 1.4;
        margin-top: 10px;
    }

    .centers-text {
        max-width: 500px;
    }

    .allotzv {
        color: #0493c3;
        font-size: 20px;
        font-family: "Manrope Bold";
        padding: 15px 30px;
        border: 2px solid #0493c3;
        border-radius: 30px;
    }

    .allotzv:hover {
        background: #0493c3;
        color: #fff;
    }

    .viborabon-last {
        background-image: url(~@/assets/hometeacher/images/viborabon-last.png);
        padding-left: 8px;
        padding-top: 1px;
        padding-bottom: 8px;
        padding-right: 8px;
    }

    .last-stav {
        padding-top: 70px;
        padding-bottom: 120px;
    }

    .last-stav h2 {
        font-size: 40px;
        font-family: "Manrope Bold Alt";
        color: #262239;
    }

    .girl-notik {
        margin-left: -25px;
        margin-bottom: 20px;
        max-width: 110%;
    }

    .liniya {
        background-image: url(~@/assets/hometeacher/images/liniya.png);
        width: 100%;
        height: 36px;
        margin-top: 30px;
    }

    @media (max-width: 1199px) {
        .obuchenie {
            overflow: hidden;
        }

        .hello {
            top: -110px;
            left: -115px;
        }
    }

    @media (max-width: 991px) {
        .abonement a {
            padding: 10px;
        }

        .centers-text {
            max-width: 100%;
            text-align: center;
        }

        .vidos {
            height: 370px;
        }

        .indotz {
            float: none;
            margin-bottom: 20px;
        }

        .blue-letters-girl h1 {
            background: none;
        }

        .bezlimit-group, .onlain-kons {
            background: none;
        }

        .obuchenie p {
            width: 100%;
        }

        .strela {
            display: none;
        }

        .hello {
            top: -160px;
        }
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        cursor: pointer;
        color: #fff;
        text-decoration: underline;
        -moz-user-select: -moz-none;
        -webkit-user-select: none;
        user-select: none;
    }

    .block {
        width: 100%;
        display: none;
    }

    input:checked ~ .block {
        display: block;
    }

    .galocka {
        margin-right: 0px !important;
        margin-top: -110px;
        float: right !important;
    }

    @media (max-width: 575px) {
        .blue-letters-girl {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-bottom: 60px;
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
        }

        .blue-letters-girl h1 {
            font-size: 40px;
            line-height: 1.1;
        }

        .blue-letters-girl h3 {
            font-size: 22px;
            margin-top: 10px;
        }

        .yellow-span {
            background-image: url(~@/assets/hometeacher/images/yellow-top-mob.png);
            font-size: 26px;
            padding-left: 8px;
            padding-top: 5px;
            padding-bottom: 11px;
            padding-right: 11px;
        }

        .vkurs {
            padding-left: 15px !important;
            padding-right: 15px !important;
            box-shadow: inset 0 3px 5px rgb(0 0 0 / 22%);
        }

        .vkurs h2 {
            font-size: 33px;
        }

        .vkurs img {
            float: none;
            max-width: 80%;
            margin-right: 0px !important;
        }

        .skyfon, .blue-letters-back {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
        }

        .skyfon h2 {
            font-size: 25px;
            line-height: 1.5;
        }

        .skyfon img {
            display: none;
        }

        .skytop {
            margin-top: 0px;
            margin-bottom: -1px;
        }

        .skydown, .skydown-white {
            margin-top: -1px;
        }

        .veselo {
            background-image: url(~@/assets/hometeacher/images/prosto-mob.png);
            padding-left: 8px;
            padding-top: 4px;
            padding-bottom: 10px;
            color: #000;
            padding-right: 10px;
        }

        .knpk-yellow {
            margin-top: 40px;
            font-size: 20px;
            padding: 15px;
        }

        .blue-letters-back h2, .last-stav h2 {
            font-size: 33px;
            text-align: center;
        }

        .viborabonement {
            background-image: url(~@/assets/hometeacher/images/viborabonement-mob.png);
            width: 240px;
            line-height: 1.2;
            margin: 0 auto;
            padding-top: 1px;
            padding-bottom: 2px;
            margin-bottom: 30px;
            margin-top: -10px;
        }

        .getpresent {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 60px;
            text-align: center;
        }

        .obuchenie {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 25px;
            padding-bottom: 0px;
            margin-bottom: -20px
        }

        .obuchenie h2 {
            font-size: 33px;
        }

        .bluekrug {
            float: left;
            margin-right: 10px;
            margin-bottom: 42px;
        }

        .sm-video, .last-stav {
            padding-left: 15px !important;
            padding-right: 15px !important;
            padding-top: 0px;
        }

        .sm-video h2 {
            font-size: 30px;
        }

        .sertifikat {
            background: none;
            padding-left: 0px;
        }

        .vidos {
            height: 280px;
        }

        .last-stav {
            background: url(~@/assets/hometeacher/images/blue-letters-back.png) repeat;
            padding-bottom: 0px;
        }
    }

</style>
